import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './themes.css';
import App from './App';
import './i18n/config'; // Initialize i18n

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);
